<template>
  <div class="tabs_content">
    <section>
      <div class="left">
        <detail-entity-info :entity="entity" />
      </div>

      <div class="right">
        <div class="field_left">
          <text-input id="configname"
                      :required="true"
                      v-model="entity.name"
                      :disabled="!isEditable"
                      ref="nameref"
          >
            <translate class="translate">Bootcast ID</translate>
          </text-input>
        </div>

        <div class="field_left">
          <text-input id="configimageurl"
                      :required="true"
                      v-model="entity.image_url"
                      :disabled="!isEditable"
                      ref="imageurlref"
          >
            <translate class="translate">URL image</translate>
          </text-input>
        </div>

        <div class="field_right">
          <text-input id="configimageversion"
                      :required="true"
                      v-model="entity.image_version"
                      :disabled="!isEditable"
                      ref="imageversionref"
          >
            <translate class="translate">Verze image</translate>
          </text-input>
        </div>

        <div class="field_left">
          <select-box
              id="channeltype"
              :options="splashTypeOptions"
              v-model="splashTypeOption"
              ref="configisthemeselectref"
          >
            <translate class="translate">Typ splash</translate>
          </select-box>
        </div>

        <div class="field_left">
          <text-input id="configsplashurl"
                      :required="true"
                      v-model="entity.splash_url"
                      :disabled="!isEditable"
                      ref="splashurlref"
          >
            <translate class="translate" :key="splashTypeOption + 'url'">URL {{ splashTypeOption }}</translate>
          </text-input>
        </div>

        <div class="field_right">
          <text-input id="configsplashversion"
                      :required="true"
                      v-model="entity.splash_version"
                      :disabled="!isEditable"
                      ref="splashversionref"
          >
            <translate class="translate" :key="splashTypeOption + 'version'">Verze {{ splashTypeOption }}</translate>
          </text-input>
        </div>

        <div class="field_left">
          <select-box
              id="configoidperator"
              v-model="entity.id_operator"
              :options="operatorOptions"
              :disabled="!allowSelectOperator"
          >
            <translate class="translate">Operátor</translate>
          </select-box>
        </div>

        <div class="field_left" v-if="entity.id_device">
          <text-input id="configiddevice"
                      v-model="entity.device_name"
                      :disabled="true"
                      ref="iddeviceref"
          >
            <translate class="translate">Zařízení</translate>
          </text-input>
        </div>

        <div class="field_right" v-if="entity.id_device">
          <a
              v-if="isEditable"
              class="btn btn_action btn_info"
              style=""
              :title="'Detail zařízení' | translate"
              @click.stop="showDeviceDetail(entity.id_device)"
              v-translate>Detail zařízení
          </a>
          <a
              v-if="isEditable"
              class="btn btn_action btn_disable"
              :title="'Zrušit přiřazení k zařízení' | translate"
              @click.stop="removeDeviceAssignment"
              v-translate>Zrušit přiřazení k zařízení
          </a>
        </div>

      </div>
    </section>

    <section class="buttons">
      <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
      <input
          v-if="$_updateActionAllowed"
          type="submit"
          :value="'Uložit' | translate"
          class="btn"
          @click.prevent.stop="$emit('saveEntity')">
    </section>

  </div>
</template>

<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";
import links from "../../../mixins/links";

export default {
  name: 'DeviceBootConfigForm',
  components: { DetailEntityInfo },
  props: {
    entity: Object,
    operatorOptions: Array,
    isEditable: Boolean,
  },
  mixins: [links],
  data() {
    return {
      moduleName: 'deviceBootConfigs',
      splashTypeOptions: [
        { id: 'splash', text: this.$gettext('Splash') },
        { id: 'theme', text: this.$gettext('Theme') },
      ],
    }
  },
  methods: {
    removeDeviceAssignment() {
      this.entity.id_device = null;
    }
  },
  computed: {
    splashTypeOption: {
      get: function() {
        return this.entity.is_theme ? 'theme' : 'splash'
      },
      set: function(value) {
        this.entity.is_theme = (value === 'theme');
      },
    },
    allowSelectOperator() {
      return this.$_loggedUser_canChangeOperator && this.$_updateActionAllowed;
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceBootConfigs/forms/DeviceBootConfigForm.vue